import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { Stats } from "../../entities/event";
import { getAnaliticEvents } from "./thunks";
import { format } from "date-fns";

interface AnalyticsState {
  loading: boolean;
  fromDate: string;
  toDate: string;
  userConnected: Stats[];
}

const initialState: AnalyticsState = {
  loading: false,
  fromDate: "2025-01-01T00:00:00",
  toDate: "2025-12-31T23:59:59",
  userConnected: [],
};

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    dateHandler: (
      state: Draft<AnalyticsState>,
      action: PayloadAction<{ _fromDate: Date; _toDate: Date }>
    ) => {
      const { _fromDate, _toDate } = action.payload;
      state.fromDate = format(_fromDate, "yyyy-MM-dd'T'00:00:00");
      state.toDate = format(_toDate, "yyyy-MM-dd'T'23:59:59");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAnaliticEvents.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAnaliticEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.userConnected = action.payload;
    });
    builder.addCase(getAnaliticEvents.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { dateHandler } = analyticsSlice.actions;

export const selectAnalyticsState = (state: RootState) => state.analytics;

export default analyticsSlice.reducer;
